// Deprecated - please do not reference this file moving forward
export var SYMBOL_MAP = {
  aed: 'د.إ',
  aud: '$',
  cad: 'C$',
  eur: '€',
  gbp: '£',
  hdk: '$',
  myr: 'RM',
  nok: 'kr',
  nzd: '$',
  sek: 'kr',
  sgd: '$',
  thb: '฿',
  usd: '$',
  zar: 'R'
};
export default (function (code) {
  return SYMBOL_MAP[code.toLowerCase()];
});